if ($('ol[style="list-style-type: upper-alpha;"]').length) {
    $('ol[style="list-style-type: upper-alpha;"]').each(function() {
        let $this = $(this);
        $this.hide();
        let $productContainer
        if($this.next('.h4').length){
            $this.next('.h4').after('<div class="products products-block product-block-posts"></div>');
            $productContainer = $this.next('.h4').next('.products-block');
        }
        else{
            $this.after('<div class="products products-block product-block-posts"></div>');
            $productContainer = $this.next('.products-block');
        }
        
       

        let codes = [];
        $this.find('li').each(function() {
            let code = $(this).text();
            if (!codes.includes(code)) {
                codes.push(code);
            }
        });
        //if ($('.admin-logged').length) {
            if (codes.length > 0) {
                let endpoint = 'https://node-7183.rostiapp.cz/api/mpdrogerie/products?codes=' + codes.join(',');
          
                $.get(endpoint, function(data) {
                    let productData = data;
                  
                    productData.forEach(function(product) {

                        if(product.OLD_PRICE_VAT === product.PRICE_VAT){
                            var saleClass = ''
                        }
                        else{
                            var saleClass = 'discount'
                        }
                        let customProductData = '<div class="product">';
                        customProductData += '<div class="p">';
                        customProductData += '<a href="' + product.URL + '" class="image">';
                        customProductData += '<img src="' + product.IMG_URL.replace('/orig/', '/detail/') + '" alt="' + product.NAME + '">';
                        customProductData += '</a>';
                        customProductData += '<div class="p-in">';
                        customProductData += '<div class="p-in-in">'
                        customProductData += '<a href="'+product.URL+'" class="name" data-micro="url" tabindex="0"><span data-micro="name" data-testid="productCardName">' + product.NAME + '</span></a>'
                        customProductData += '</div>'
                        customProductData += '<div class="p-bottom single-button">'
                            customProductData += '<div data-micro="offer">'
                            customProductData += '<div class="prices '+saleClass+'">'
                            if(getShoptetDataLayer('customer').registered){
                                    if(product.OLD_PRICE_VAT !== product.PRICE_VAT){
                                        customProductData += '<div class="price price-final" data-testid="productCardPrice"><strong>'+Number(product.PRICE_VAT).ShoptetFormatAsCurrency()+'</strong></div>'
                                    }
                                    else{
                                        customProductData += '<span class="price-standard"><span>'+Number(product.OLD_PRICE_VAT).ShoptetFormatAsCurrency()+'</span></span>'
                                        customProductData += '<div class="price price-final" data-testid="productCardPrice"><strong>'+Number(product.PRICE_VAT).ShoptetFormatAsCurrency()+'</strong></div>'
                                    }
                                    customProductData += '</div>'
                            }
                                customProductData += '<div class="p-tools">'
                                    customProductData += '<a href="'+product.URL+'" class="btn btn-primary" tabindex="0">Detail</a>'
                                    
                                customProductData += '</div>'
                               
                            customProductData += '</div>'
                        customProductData += '</div>'
                        customProductData += '</div>'
                        customProductData += '</div>'
                        customProductData += '</div>'
                                   
                        $productContainer.append(customProductData);
                    });
                }).done(function(){
                    $productContainer.slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerMode: false,
                        autoplay: false,
                        autoplaySpeed: 5000,
                        dots: true,
                        arrows: false,
                        infinite: false,
                        adaptiveHeight: false,
                        responsive: [
                
                         
                         {
                            breakpoint: 1199,
                            settings: {
                              slidesToShow: 3,
                              slidesToScroll: 1,
                             
                            }
                          },
                           
                          
                          {
                            breakpoint: 768,
                            settings: {
                             slidesToShow: 2,
                             slidesToScroll: 2,
                           }
                           
                          }
                          
                        ]
                    });
                    
                })
            }
      //  }
    });

        
    
}